<template>
  <div class="talent-testimonials__wrapper">
    <div class="talent-testimonials__container">
      <div class="talent-testimonials__content">
        <div class="talent-testimonials__title">Хто ми такі</div>
        <div class="talent-testimonials__list">
          <div
            class="talent-testimonials__list-item talent-testimonials__list-item-first"
          >
            <div class="talent-testimonials__list-item-header">
              <img
                src="/static/img/director-1.svg"
                alt="Фото відгуку"
                class="talent-testimonials__list-item-img"
              />
              <p class="talent-testimonials__list-item-name">Оксана</p>
            </div>
            <div class="talent-testimonials__list-item-text">
              <div class="talent-testimonials__list-item-text-br">
                Кастинг-директорка. Засновниця Mama Casting.
              </div>
              <div class="talent-testimonials__list-item-text-br">
                Співпрацювала з Radioaktive film Toy Pictures, NO STARS, The
                Martini Shot, DGTL RLGN. Робила кастинг для Eurosport, GUINNESS,
                ATLAS WEEKEND, Kyivstar, Vodafone, Ощад Банк, ProCredit Bank,
                PUMB, Helen Marlen, Нова Пошта та багато інших.
              </div>
              Кастинг для повного метру «Назавжди-назавжди».
            </div>
            <div class="talent-testimonials__list-item-mobile-text">
              Кастинг-директорка. Засновниця Mama Casting. Співпрацювала з
              Radioaktive film Toy Pictures, NO STARS, The Martini Shot, DGTL
              RLGN. Робила кастинг для Eurosport, GUINNESS, ATLAS WEEKEND,
              Kyivstar, Vodafone, Ощад Банк, ProCredit Bank, PUMB, Helen Marlen,
              Нова Пошта та багато інших. Кастинг для повного метру
              «Назавжди-назавжди».
            </div>
          </div>
          <div class="talent-testimonials__list-item">
            <div class="talent-testimonials__list-item-header">
              <img
                src="/static/img/director-2.svg"
                alt="Фото відгуку"
                class="talent-testimonials__list-item-img"
              />
              <p class="talent-testimonials__list-item-name">Катерина</p>
            </div>
            <div class="talent-testimonials__list-item-text">
              <div class="talent-testimonials__list-item-text-br">
                Продюсерка рекламних проєктів.
              </div>
              Працювала з такими брендами як Coca-Cola, Rozetka, Чернігівське,
              Roshen, Philips, Rowenta, Huawei , BMW, L’oreal та багатьма
              іншими. Співпрацювала з такими  продакшенами як Radioaktive, Toy
              Pictures, Esse House.
            </div>
            <div class="talent-testimonials__list-item-mobile-text">
              Продюсерка рекламних проєктів. Працювала з такими брендами як
              Coca-Cola, Rozetka, Чернігівське, Roshen, Philips, Rowenta, Huawei
              , BMW, L’oreal та багатьма іншими. Співпрацювала з такими 
              продакшенами як Radioaktive, Toy Pictures, Esse House.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "talent-testimonials-block",
  data() {
    return {
      items: [
        {
          name: "Оксана",
          url: "/static/img/director-1.svg",
          text:
            "Кастинг-директорка. Засновниця Mama Casting.\n\n" +
            "Співпрацювала з Radioaktive film Toy Pictures, NO STARS, The Martini Shot, DGTL RLGN. Робила кастинг для Eurosport, GUINNESS, ATLAS WEEKEND, Kyivstar, Vodafone, Ощад Банк, ProCredit Bank, PUMB,  Helen Marlen, Нова Пошта та багато інших. \n\n" +
            "Кастинг для повного метру «Назавжди-назавжди».",
          mobileText:
            "Кастинг-директорка. Засновниця Mama Casting.\n\n" +
            "Співпрацювала з Radioaktive film Toy Pictures, NO STARS, The Martini Shot, DGTL RLGN. Робила кастинг для Eurosport, GUINNESS, ATLAS WEEKEND, Kyivstar, Vodafone, Ощад Банк, ProCredit Bank, PUMB,  Helen Marlen, Нова Пошта та багато інших. \n\n" +
            "Кастинг для повного метру «Назавжди-назавжди».",
        },
        {
          name: "Катерина",
          url: "/static/img/director-2.svg",
          text:
            "Продюсерка рекламних проєктів. \n\n" +
            "Працювала з такими брендами як Coca-Cola, Rozetka, Чернігівське, Roshen, Philips, Rowenta, Huawei , BMW, L’oreal та багатьма іншими. Співпрацювала з такими  продакшенами як Radioaktive, Toy Pictures, Esse House.",
          mobileText:
            "Продюсерка рекламних проєктів. \n\n" +
            "Працювала з такими брендами як Coca-Cola, Rozetka, Чернігівське, Roshen, Philips, Rowenta, Huawei , BMW, L’oreal та багатьма іншими. Співпрацювала з такими  продакшенами як Radioaktive, Toy Pictures, Esse House.",
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Light.woff2") format("woff2");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Regular.woff2") format("woff2");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Medium.woff2") format("woff2");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Nyght Serif";
  src: url("/static/fonts/NyghtSerif-Bold.woff2") format("woff2");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
.talent-testimonials {
  &__wrapper {
    max-width: 1440px;
    margin: 0 auto;
    width: 100%;
  }

  &__container {
    padding: 160px 80px;
  }

  &__title {
    font-size: 60px;
    line-height: 60px;
    font-weight: 500;
    letter-spacing: -0.02em;
    text-align: center;
    padding-bottom: 60px;
    font-family: "Inter", sans-serif;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    column-gap: 24px;
    &-item {
      padding-right: 85px;

      &-first {
        padding-right: 60px;
      }

      &-header {
        max-width: 540px;

        display: flex;
        align-items: center;
        padding-bottom: 20px;
        column-gap: 32px;
      }

      &-name {
        font-size: 60px;
        line-height: 60px;
        font-weight: 300;
        letter-spacing: -0.02em;
        font-family: "Nyght Serif";
      }

      &-img {
        width: 110px;
        height: 110px;
        object-fit: cover;
        border-radius: 55px;

        @media (max-width: 767px) {
          width: 60px;
          height: 60px;
        }
      }

      &-text {
        padding-top: 20px;
        border-top: 1px solid #0000004d;
        max-width: 540px;
        font-size: 20px;
        font-weight: 400;
        white-space: pre-line;
        font-family: "Inter", sans-serif;

        &-br {
          margin-bottom: 10px;

          @media (max-width: 767px) {
            margin-bottom: 0;
          }
        }
      }

      &-mobile {
        &-text {
          display: none;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .talent-testimonials {
    &__container {
      padding: 118px 24px;
    }

    &__list {
      &-item {
        padding-right: 0;
      }
    }
  }
}

@media (max-width: 868px) {
  .talent-testimonials {
    &__title {
      font-size: 36px;
      line-height: 36px;
    }

    &__list {
      &-item {
        padding-right: 0;
        &-header {
          padding-bottom: 16px;
          max-width: 100%;
        }

        &-text {
          padding-top: 16px;
          font-size: 16px;
          max-width: 100%;
        }

        &-name {
          font-size: 36px;
        }
      }
    }
  }
}

@media (max-width: 868px) {
  .talent-testimonials {
    &__title {
      padding-bottom: 36px;
      text-align: start;
    }

    &__list {
      flex-direction: column;
      row-gap: 32px;

      &-item {
        &-mobile-text {
          display: block;
          padding-top: 16px;
          border-top: 1px solid #0000004d;
          font-size: 16px;
          white-space: pre-line;
        }

        &-text {
          display: none;
        }
      }
    }
  }
}
</style>
